module.exports = __webpack_public_path__ + "img/qrcode.b609a709.png";